import React, { useState } from 'react';
import { X } from 'lucide-react';

interface UnpublishArchiveConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (note: string) => Promise<void>;
  unpublishing: boolean;
}

const UnpublishArchiveConfirmModal: React.FC<UnpublishArchiveConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  unpublishing,
}) => {
  const [note, setNote] = useState('');

  if (!open) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onConfirm(note);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="unpublish-modal-title"
      data-testid="unpublish-archive-confirm-modal"
    >
      <div className="card max-w-md w-full relative">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-secondary-400 hover:text-white"
          aria-label="Close"
          disabled={unpublishing}
        >
          <X className="h-5 w-5" />
        </button>
        <h2 id="unpublish-modal-title" className="text-lg font-semibold text-white mb-2">
          Unpublish VOD
        </h2>
        <p className="text-sm text-secondary-400 mb-4">
          This removes the VOD from the league archive and unlinks it from the schedule match.
          Review history will be preserved.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="flex flex-col gap-1 text-sm">
            <span className="text-secondary-400">Reason for unpublishing, optional</span>
            <textarea
              className="input-field min-h-[80px]"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              disabled={unpublishing}
              placeholder="Optional note for review history"
              data-testid="unpublish-note-input"
            />
          </label>
          <div className="flex gap-3 justify-end">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={unpublishing}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-secondary text-red-300 border-red-800 hover:bg-red-900/30"
              disabled={unpublishing}
            >
              {unpublishing ? 'Unpublishing...' : 'Unpublish VOD'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UnpublishArchiveConfirmModal;
